<template>
    <div>
        <v-toolbar color="grey-lighten-2" flat border density="compact" class="mb-5" height="auto">
            <v-toolbar-title v-if="destinationLocation">
                <div class="d-flex align-left align-lg-center flex-column flex-lg-row">
                    <div>{{ destinationLocation.name }}, {{ destinationLocation.countryName }}</div>
                    <div class="text-subtitle-2 ml-lg-4 font-weight-regular">
                        <span v-if="destination.dateFrom">
                            {{ $filters.dateFormat(destination.dateFrom) }}
                        </span>
                        <span v-if="destination.dateTo"> - {{ $filters.dateFormat(destination.dateTo) }} </span>
                    </div>
                    <div v-if="nights" class="text-subtitle-2 ml-lg-4 font-weight-regular">
                        {{ nights + 1 }} {{ $t('day', nights + 1) }} / {{ nights }} {{ $t('night', nights) }}
                    </div>
                </div>
            </v-toolbar-title>
            <template v-if="!$breakpoint.smAndDown && !isReadOnly">
                <v-btn
                    v-if="!$conf.public.account.hideAddServiceBtn && personRole !== 'dispatcher'"
                    variant="text"
                    size="small"
                    @click="addService"
                >
                    {{ $t('add_service') }}
                </v-btn>
                <v-btn
                    v-if="
                        ((isB2B && !$conf.public.account.addOfflineServiceTO1Only) || isTO1) &&
                        personRole !== 'dispatcher'
                    "
                    variant="text"
                    size="small"
                    @click="addOfflineService"
                >
                    {{ $t('add_offline_service') }}
                </v-btn>
                <v-btn icon="mdi-pencil" variant="text" size="small" color="primary" @click="edit" />
                <delete-with-confirmation @remove="remove">
                    <template v-slot:activator="{props}">
                        <v-btn icon="mdi-delete-forever" variant="text" v-bind="props" />
                    </template>
                </delete-with-confirmation>
            </template>
            <v-menu v-else-if="!isReadOnly" v-model="mobileMenu">
                <template v-slot:activator="{props}">
                    <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props" />
                </template>
                <v-list density="compact">
                    <v-list-item
                        v-if="!$conf.public.account.hideAddServiceBtn && personRole !== 'dispatcher'"
                        @click="addService"
                    >
                        <template v-slot:prepend><v-icon>mdi-plus</v-icon></template>
                        <v-list-item-title>{{ $t('add_service') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        v-if="
                            ((isB2B && !$conf.public.account.addOfflineServiceTO1Only) || isTO1) &&
                            personRole !== 'dispatcher'
                        "
                        @click="addOfflineService"
                    >
                        <template v-slot:prepend><v-icon>mdi-plus</v-icon></template>
                        <v-list-item-title>{{ $t('add_offline_service') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="edit">
                        <template v-slot:prepend><v-icon>mdi-pencil</v-icon></template>
                        <v-list-item-title>{{ $t('edit') }}</v-list-item-title>
                    </v-list-item>
                    <delete-with-confirmation @remove="remove">
                        <template v-slot:activator="{props}">
                            <v-list-item v-bind="props">
                                <template v-slot:prepend><v-icon>mdi-delete-forever</v-icon></template>
                                <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
                            </v-list-item>
                        </template>
                    </delete-with-confirmation>
                </v-list>
            </v-menu>
        </v-toolbar>
        <slot />
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop, Emit, Inject} from 'vue-facing-decorator'
    import {nights} from '~/utils/helpers'
    import DeleteWithConfirmation from '~/components/DeleteWithConfirmation.vue'

    @Component({
        components: {DeleteWithConfirmation},
    })
    export class OrderDestination extends Vue {
        @Prop({required: true}) destination
        @Prop({required: true}) destinationLocation
        @Inject({default: false}) isReadOnly

        mobileMenu = false

        @Emit()
        edit() {
            return this.destination
        }

        @Emit()
        remove() {}

        @Emit()
        addService() {
            return this.destination
        }

        @Emit()
        addOfflineService() {
            return this.destination
        }

        get nights() {
            if (this.destination.dateFrom && this.destination.dateTo) {
                return nights(this.destination.dateFrom, this.destination.dateTo)
            }
            return null
        }

        get personRole() {
            return authStore.personRole
        }

        get isB2B() {
            return authStore.isB2B
        }

        get isTO1() {
            return authStore.isTO1
        }
    }

    export default OrderDestination
</script>
